import { Button } from "~/components/ui/button";
import { SEARCH_ENTITY_TYPES, SearchEntityType } from "~/services/search";
import { ENTITY_TYPE_LABEL, entityIcon } from "./constants";

interface EntityTypeCountsProps {
  counts: Partial<Record<SearchEntityType, number>>;
  inaccessible: SearchEntityType[];
  onSelect: (entityType: SearchEntityType) => void;
}

/**
 * Hit counts per type, each a way to narrow to it. An inaccessible type says so
 * rather than showing a zero no rephrasing could change.
 */
export const EntityTypeCounts = ({ counts, inaccessible, onSelect }: EntityTypeCountsProps) => (
  <div className="flex flex-wrap items-center gap-2" data-testid="search-type-counts">
    {SEARCH_ENTITY_TYPES.filter(
      (entityType) => entityType in counts || inaccessible.includes(entityType)
    ).map((entityType) =>
      inaccessible.includes(entityType) ? (
        <span
          key={entityType}
          className="flex items-center gap-1.5 rounded-md border border-dashed border-border px-3 py-1 text-sm text-muted-foreground"
        >
          {entityIcon(entityType)}
          {ENTITY_TYPE_LABEL[entityType]} — no access
        </span>
      ) : (
        <Button
          key={entityType}
          variant="outline"
          size="sm"
          className="gap-1.5"
          onClick={() => onSelect(entityType)}
        >
          {entityIcon(entityType)}
          {ENTITY_TYPE_LABEL[entityType]}
          <span className="tabular-nums text-muted-foreground">{counts[entityType]}</span>
        </Button>
      )
    )}
  </div>
);
